import React, { Component } from "react";
import { connect } from "react-redux";
import { updateContentFeed } from "signoxe/actions";
import Icon from "../Icon";
import './styles.scss';
import loader1 from '../../../images/animations/loader1.gif'

const CloseIcon = (color) => {
  return (
    <svg fill={color.color} height="20" width="20" viewBox="0 0 20 20">
      <path fill={color.color} d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
    </svg>
  );
};

class Widget extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      screenResolutionModal: false,
      screenWidthInput: this.props.device.screen_width_in_pixels || '',
      screenHeightInput: this.props.device.screen_height_in_pixels || '',
      screenResolution: this.props.device.screen_width_in_pixels == null && this.props.device.screen_height_in_pixels == null
        ? "Default Screen Resolution"
        : "Custom Screen Resolution",
      saving: false,
    };
  }

  handleScreenResolutionChange = (screenWidth, screenHeight) => {
    this.props.onDeviceChange({
      id: this.props.device.id,
      screen_width_in_pixels: screenWidth,
      screen_height_in_pixels: screenHeight,
    }).then(() => {
      this.setState({ screenResolutionModal: false });
    });
  };
  

  render() {
    const screenResolution_ = this.props.device.screen_width_in_pixels == null && this.props.device.screen_height_in_pixels == null;

    const screenWidthNullEmpty = this.state.screenWidthInput == null || this.state.screenWidthInput === '';
    const screenHeightNullEmpty = this.state.screenHeightInput == null || this.state.screenHeightInput === '';

    return (
      <>
        <div className="screenResolution">
          <select
            // Your select element and options here
            ref={this.select}
            title={`Screen Resolution${
              screenResolution_? 
                '' 
              : ` ( ${this.props.device.screen_width_in_pixels} by ${this.props.device.screen_height_in_pixels} )`}`}
            value={this.state.screenResolution}
            onChange={(e) => {
              const selectedValue = e.currentTarget.value;
              this.setState({ screenResolution: selectedValue });
              if (selectedValue === "Default Screen Resolution") {
                this.handleScreenResolutionChange(null, null);
              } else {
                this.setState({ screenResolutionModal: true });
              }
            }}
          >
            <option value="Default Screen Resolution">Default </option>
            <option value="Custom Screen Resolution">
              {screenResolution_
                ? 'Custom'
                : `${this.props.device.screen_width_in_pixels}px by ${this.props.device.screen_height_in_pixels}px`}
            </option>
          </select>

          {screenResolution_ ? null : (
            <div className="editIcon">
              <Icon
                title="Edit Resolution"
                name="edit"
                size="1.35rem"
                onClick={() => this.setState({ screenResolutionModal: true })} 
              />
            </div>
          )}
        </div>

        {this.state.screenResolutionModal && (
          <div className="screenResolutionModal_Overlay">
            <div className='screenResolutionModal'>
              <div className="closeModalBtn_Overlay">
                <b>{`Screen Resolution : ${this.state.screenWidthInput}px by ${this.state.screenHeightInput}px`}</b>
                <button onClick={this.handleScreenResolutionChange.bind(this, null, null)}>
                  <CloseIcon color={'black'}/>
                </button>
              </div>

              <div className="input_Overlay">
                <form
                  action=""
                  onSubmit={async (e) => {
                    e.preventDefault();
                    if (screenWidthNullEmpty || screenHeightNullEmpty) {
                      this.handleScreenResolutionChange(null, null);
                    } else {
                      if (!this.state.saving) {
                        this.setState({ saving: true });
                        await this.handleScreenResolutionChange(
                          this.state.screenWidthInput,
                          this.state.screenHeightInput
                        );
                        this.setState({ saving: false });
                      }
                    }
                  }}
                  className=""
                >
                  <label htmlFor="screenWidthInPixels" className="">
                    <span>Width:</span>
                    <input
                      ref={this.inputRef1}
                      value={this.state.screenWidthInput}
                      onChange={(e) => {
                        this.setState({ screenWidthInput: e.currentTarget.value });
                      }}
                      type="number"
                      className="screenWidthInPixels"
                    />
                  </label>

                  <label htmlFor="screenHeightInPixels" className="">
                    <span>Height:</span>
                    <input
                      ref={this.inputRef2}
                      value={this.state.screenHeightInput}
                      onChange={(e) => {
                        this.setState({ screenHeightInput: e.currentTarget.value });
                      }}
                      type="number"
                      className="screenHeightInPixels"
                    />
                  </label>

                  <div className="saveBTN_Overlay">
                    {this.state.saving ? (
                      <div>
                        <img src={loader1} width="24" height="24" />
                        <button disabled={this.state.saving}>Saving...</button>
                      </div>
                    ) : (
                      <button>Save</button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
   
  };
};

export const ScreenResolutionSelectWidget = connect(
  mapStateToProps,
  mapDispatchToProps
)(Widget);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ScreenResolutionSelectWidget/index.js